import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ConfettiExplosion from 'react-confetti-explosion';

interface QuizCongratulationsProps {
  isConfettiExploding: boolean;
  onResetProgress: () => void;
}

const QuizCongratulations: React.FC<QuizCongratulationsProps> = ({
  isConfettiExploding,
  onResetProgress,
}) => {
  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxWidth: 400,
          width: '100%',
          textAlign: 'center',
          zIndex: 1001,
        }}
      >
        {isConfettiExploding && (
          <Box
            sx={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000,
            }}
          >
            <ConfettiExplosion
              force={0.8}
              duration={3000}
              particleCount={100}
              width={1600}
            />
          </Box>
        )}
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
          Congratulations! 🎉
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
          You have completed this module! Click the button below to reset
          your progress.
        </Typography>
        <Button
          variant="contained"
          onClick={onResetProgress}
          sx={{
            minWidth: 120,
            fontWeight: 'bold',
            textTransform: 'none',
            fontSize: '1rem',
          }}
        >
          Reset Progress
        </Button>
      </Box>
    </>
  );
};

export default QuizCongratulations;
